export default "__VITE_ASSET__3fcbb846__"